import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { CitiesService } from '@src/api';
import { AlertService } from '@src/core/services';
import { preventSearchString } from '@src/utils';

import { SEARCH_MIN_LENGTH } from '../constants';
import { InputItemType } from '../types';

@Injectable({
  providedIn: 'root',
})
export class SearchCitiesService {
  readonly topCities$ = new BehaviorSubject<Array<InputItemType> | null>(null);
  readonly searchCities$ = new BehaviorSubject<Array<InputItemType> | null>(null);

  private readonly citiesService = inject(CitiesService);
  private readonly alertService = inject(AlertService);

  loadTopCities() {
    this.citiesService
      .apiCitiesTopGet()
      .pipe(
        catchError(err => {
          this.alertService.error(err);
          return throwError(() => err);
        }),
      )
      .subscribe(topCities => {
        this.topCities$.next(topCities);
      });
  }

  resetTopCities() {
    this.topCities$.next(null);
  }

  searchCities(text: string) {
    if (!text || preventSearchString(text, SEARCH_MIN_LENGTH)) {
      this.resetSearchCities();
    } else {
      this.citiesService
        .apiCitiesSearchGet(text)
        .pipe(
          catchError(err => {
            this.alertService.error(err);
            return throwError(() => err);
          }),
        )
        .subscribe(searchCities => {
          this.searchCities$.next(searchCities);
        });
    }
  }

  getCityById(cityId: number) {
    return this.citiesService.apiCitiesCityIdGet(cityId).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
    );
  }

  resetSearchCities() {
    this.searchCities$.next(null);
  }
}
